// extracted by mini-css-extract-plugin
export default {"recos":"Q4-z","productCardOverride":"R4-z","rowHasBadge":"S4-z"};